<template>
    <div class="upload-box">
        <div class="upload-loading" v-show="messageInfo.loading">
            <!-- <el-progress :percentage="percentage"></el-progress> -->
            <p v-show="percentage == 0">正在读取文件...</p>
            <p v-show="percentage > 0">正在上传{{ percentage }}%</p>
        </div>
        <el-upload class="upload-demo" action="" ref="upload" :file-list="fileList" :limit="2" :on-change="handleChange"
            :on-remove="handleRemove" :auto-upload="false" accept="">
            <el-button class="xxx-btn"></el-button>
            <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitForm">上传到服务器</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="resumeUpload">继续</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="stopUpload">暂停</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="abortMultipartUpload">清除切片
            </el-button> -->
        </el-upload>
        <div class="upload-success" v-show="isSuccess">
            <img src="https://oss.eventnet.cn/H5/72Hours/img/success.png">
        </div>
    </div>
</template>

<script>
// let OSS = require('ali-oss') // 引入ali-oss插件
import OSS from 'ali-oss';
import CryptoJS from 'crypto-js';
import { uuid } from '../Toolset';
const client = new OSS({
    region: 'oss-cn-zhangjiakou',//根据那你的Bucket地点来填写
    accessKeyId: 'LTAI4G8tYu8iSpi1rMEGwmEG',//自己账户的accessKeyId
    accessKeySecret: '9cEMIWM684weqaRUroE31UZI8pNPvp',//自己账户的accessKeySecret
    bucket: '1yue-server-resource2',//bucket名字
});
export default {
    name: 'upload',
    data() {
        return {
            fileList: [],
            file: null,
            tempCheckpoint: null, // 用来缓存当前切片内容
            uploadId: '',
            uploadStatus: null, // 进度条上传状态
            percentage: 0, // 进度条百分比
            uploadName: '',  //Object所在Bucket的完整路径
            md5: "",
            string: [],
            fileSize: 1024 * 1024 * 5,
            uuid: '',
            ossFolder: '/20220429-72Hours/',
            ossRename: '',
            messageInfo: {
                loading: false,
                fileUrl: null,
            },
            isMd5: false,
            isSuccess: false
        }
    },
    mounted() {
        const THAT = this;
        THAT.uuid = uuid();
        // console.log('😀UUID ==>>>', THAT.uuid);
        // this.test()
        window.addEventListener('online', this.resumeUpload);
    },
    methods: {
        init(name) {
            this.messageInfo.loading = name;
        },
        // 点击上传至服务器
        async submitForm() {
            const THAT = this;
            // 如果文件大学小于分片大小，使用普通上传，否则使用分片上传
            if (THAT.file.size <= THAT.fileSize) {
                // console.log('普通上传');
                THAT.commonUpload();
            } else {
                // console.log('分片上传');
                THAT.multipartUpload();
            }
        },
        // 取消分片上传事件
        async abortMultipartUpload() {
            window.removeEventListener('online', this.resumeUpload)
            const name = this.uploadName; // Object所在Bucket的完整路径。
            const uploadId = this.upload; // 分片上传uploadId。
            const result = await client.abortMultipartUpload(name, uploadId);
            // console.log('=======清除切片====', name, uploadId, result);
        },
        // 暂停分片上传。
        stopUpload() {
            window.removeEventListener('online', this.resumeUpload) // 暂停时清除时间监听
            let result = client.cancel();
            // console.log(result, '---------暂停上传-----------')
        },
        // 普通上传
        async commonUpload() {
            const THAT = this;
            if (!this.file) {
                this.$message.error('请选择文件')
                return
            }
            const suffix = /\.([0-9A-z]+)$/.exec(THAT.file.name)[1] // 获取上传文件后缀名
            const timestamp = Date.now();
            let timeRename = THAT.ossFolder + THAT.uuid + '-' + timestamp + '.' + suffix; // 重新定义文件名
            return client
                .put(timeRename, this.file)
                .then(result => {
                    // console.log('result === ', result);
                    THAT.isMd5 = false;
                    THAT.messageInfo.loading = false;
                    THAT.messageInfo.fileUrl = result.name;
                    THAT.$emit('buttonEvent', THAT.messageInfo);
                    // cToast({
                    //     content: "上传成功",
                    //     duration: 1500,
                    //     onHide: function () { /* 关闭后的回调，基本用不着 */ }
                    // });
                    THAT.isSuccess = true;
                    setTimeout(function () {
                        THAT.isSuccess = false;
                    }, 1500)
                })
                .catch(err => {
                    // console.log('failed ===', err);
                    THAT.messageInfo.loading = false;
                    THAT.$emit('buttonEvent', THAT.messageInfo);
                    cToast({
                        content: "网络延时，请重新上传",
                        duration: 1500,
                        onHide: function () { /* 关闭后的回调，基本用不着 */ }
                    });
                });
        },
        // 切片上传
        async multipartUpload() {
            const THAT = this;
            if (!this.file) {
                this.$message.error('请选择文件')
                return
            }
            const suffix = /\.([0-9A-z]+)$/.exec(THAT.file.name)[1] // 获取上传文件后缀名
            const timestamp = Date.now();
            THAT.ossRename = THAT.ossFolder + THAT.uuid + '-' + timestamp + '.' + suffix; // 重新定义文件名
            // console.log("🚀 ~ file: Upload.vue ~ line 101 ~ multipartUpload ~ suffix", suffix, Date.now())
            this.uploadStatus = null
            // console.log("this.uploadStatus",this.file, this.uploadStatus);
            this.percentage = 0;
            // console.log('-------->>>>', this.file.type);
            try {
                //object-name可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
                let result = await client.multipartUpload(THAT.ossRename, this.file, {
                    headers: {
                        'Content-Disposition': 'inline',
                        'Content-MD5': this.md5,
                        'Content-Type': this.file.type //注意：根据图片或者文件的后缀来设置，我试验用的‘.png’的图片，具体为什么下文解释
                    },
                    partsSize: THAT.fileSize,
                    progress: (p, checkpoint) => {
                        this.tempCheckpoint = checkpoint;
                        // console.log(checkpoint);
                        this.string = checkpoint.doneParts;
                        this.upload = checkpoint.uploadId
                        this.uploadName = checkpoint.name
                        this.percentage = Math.floor(p * 100);
                        // console.log(p, checkpoint, this.percentage, '---------uploadId-----------')
                        // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
                    },
                    checkpoint: this.tempCheckpoint,
                    meta: { year: 2022, people: 'dev' },
                    mime: this.file.type
                }).then(({ res, name }) => {
                    if (res && res.status == 200) {
                        // console.log(`阿里云OSS上传图片成功回调`, res, name);
                        THAT.isMd5 = false;
                        THAT.messageInfo.loading = false;
                        THAT.messageInfo.fileUrl = name;
                        THAT.$emit('buttonEvent', THAT.messageInfo);
                        // cToast({
                        //     content: "上传成功",
                        //     duration: 1500,
                        //     onHide: function () { /* 关闭后的回调，基本用不着 */ }
                        // });
                        THAT.isSuccess = true;
                        setTimeout(function () {
                            THAT.isSuccess = false;
                        }, 1500)
                    }
                }).catch((err) => {
                    // console.log(`阿里云OSS上传图片失败回调`, err);
                    THAT.messageInfo.loading = false;
                    THAT.$emit('buttonEvent', THAT.messageInfo);
                    cToast({
                        content: "网络延时，请重新上传",
                        duration: 1500,
                        onHide: function () { /* 关闭后的回调，基本用不着 */ }
                    });
                });
                // console.log('result= 切片上传完毕=', result, this.percentage,);
            } catch (e) {
                window.addEventListener('online', this.resumeUpload) // 该监听放在断网的异常处理
                // 捕获超时异常。
                if (e.code === 'ConnectionTimeoutError') { // 请求超时异常处理
                    this.uploadStatus = 'exception'
                    // console.log("TimeoutError");
                    // do ConnectionTimeoutError operation
                }
                // console.log(e)
            }
        },
        binary2base64(bi) {
            let str = '';
            for (let i = 0, len = bi.length; i < len; i++) {
                str += String.fromCharCode(bi[i]);
            }
            return btoa(str);
        },
        strToBinary(str) {
            var result = [];
            var list = str.split("");
            for (var i = 0; i < list.length; i++) {
                if (i != 0) {
                    result.push(" ");
                }
                var item = list[i];
                var binaryStr = item.charCodeAt().toString(2);
                result.push(binaryStr);
            }
            return result.join("");
        },
        // 恢复上传。
        async resumeUpload() {
            const THAT = this;
            window.removeEventListener('online', this.resumeUpload)
            if (!this.tempCheckpoint) {
                this.$message.error('请先上传')
                return
            }
            this.uploadStatus = null
            try {
                let result = await client.multipartUpload(THAT.ossRename, this.file, {
                    headers: {
                        'Content-Disposition': 'inline',
                        'Content-MD5': this.md5,
                        'Content-Type': this.file.type // 注意：根据图片或者文件的后缀来设置，我试验用的‘.png’的图片，具体为什么下文解释
                    },

                    progress: (p, checkpoint) => {
                        this.percentage = Math.floor(p * 100);
                        // console.log(p, checkpoint, 'checkpoint----恢复上传的切片信息-------')
                        this.tempCheckpoint = checkpoint;
                    },
                    partsSize: THAT.fileSize,
                    checkpoint: this.tempCheckpoint,
                    meta: { year: 2022, people: 'dev' },
                    mime: this.file.type
                })
                // console.log(result, 'result-=-=-恢复上传完毕')
            } catch (e) {
                // console.log(e, 'e-=-=-');
            }
        },
        // 选择文件发生改变
        handleChange(file, fileList) {
            // console.log(file, fileList);
            const THAT = this;
            THAT.fileList = fileList.filter(row => row.uid == file.uid)
            THAT.file = file.raw;
            const suffix = /\.([0-9A-z]+)$/.exec(THAT.file.name)[1] // 获取上传文件后缀名
            if (suffix != 'zip' && suffix != 'rar') {
                cToast({
                    content: "请以rar/zip压缩包格式打包上传",
                    duration: 1500,
                    onHide: function () { /* 关闭后的回调，基本用不着 */ }
                });
                return false;
            }
            THAT.messageInfo.loading = true;
            THAT.$emit('buttonEvent', THAT.messageInfo);
            let FileReader1 = new FileReader();
            FileReader1.readAsDataURL(file.raw)
            FileReader1.onload = function (e) {
                THAT.md5 = CryptoJS.MD5(CryptoJS.enc.Latin1.parse(e.target.result)).toString(CryptoJS.enc.Base64);
                // console.log('👿 MD5-Base64 ==>>>', THAT.md5);
                // console.log('👿 CryptoJS.MD5 ==>>>', CryptoJS.MD5(CryptoJS.enc.Latin1.parse(e.target.result)).toString());
            };
            // 文件改变时上传
            THAT.submitForm(file)
            // fileList: [],
            // file: null,
            // tempCheckpoint: null, // 用来缓存当前切片内容
            // uploadId: '',
            // uploadStatus: null, // 进度条上传状态
            // percentage: 0, // 进度条百分比
            // uploadName: '',  //Object所在Bucket的完整路径
            // md5: "",
            // string: [],
        },
        handleRemove(file, fileList) {
            this.percentage = 0 //进度条置空
            this.fileList = []
        },
    }
}
</script>

<style lang="scss" scoped>
.upload-loading,
.upload-success {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 9999;
    background: rgba(0, 3, 107, .5);
    // border: solid 10px yellow;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.upload-success {
    margin-bottom: 50px;
}

.upload-box {
    position: relative;

    .xxx-btn {
        position: absolute;
        top: 0;
        left: 0;
        width: 199px !important;
        height: 61px !important;
        border: none !important;
        background: transparent !important;
        cursor: pointer;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Upload.vue